import { getRateInAllFormats } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import isConsideredMidmarketRate from '../resources/isConsideredMidmarketRate';

import componentStyles from './ExchangeRateIndicator.module.less';

const ExchangeRateIndicator = ({
  styles,
  referenceRate,
  rate,
  label,
  sourceCurrency,
  targetCurrency,
}) => {
  const derivedStyles = { ...componentStyles, ...styles };
  const { locale, formatMessage } = useIntl();
  const rateInAllFormats = getRateInAllFormats(rate, sourceCurrency, targetCurrency, {}, locale);

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <>
      <span className={derivedStyles.rateAndIndicator} data-testid="exchange-rate-indicator">
        {referenceRate &&
          (isConsideredMidmarketRate(rate, referenceRate) ? (
            <span
              className={derivedStyles.goodExchangeRate}
              aria-label={formatMessage({ id: 'good-exchange-rate' })}
            />
          ) : (
            <span
              className={derivedStyles.badExchangeRate}
              aria-label={formatMessage({ id: 'bad-exchange-rate' })}
            />
          ))}
        <span className={derivedStyles.rate}>
          {rateInAllFormats ? rateInAllFormats.formats?.equation.calculationInDecimal : null}
        </span>
      </span>
      {label}
    </>
  );
};

ExchangeRateIndicator.propTypes = {
  styles: PropTypes.shape({
    rateAndIndicator: PropTypes.string,
    goodExchangeRate: PropTypes.string,
    badExchangeRate: PropTypes.string,
  }),
  sourceCurrency: PropTypes.string.isRequired,
  targetCurrency: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  referenceRate: PropTypes.number,
  label: PropTypes.element,
};

ExchangeRateIndicator.defaultProps = {
  styles: {},
  referenceRate: undefined,
  label: undefined,
};

export default ExchangeRateIndicator;
